<template>
    <b-card :style="{'max-width': '1024px', 'width': '90%', 'margin-left': 'auto', 'margin-right': 'auto', 'margin-top': '10px'}">
        <b-card-text>
            <h4>Shipping Items</h4>
        </b-card-text>

        <b-card>
            <div v-if="location_counts.length>0">
                <b-button :pressed="location_id == location_count.location_id" variant="outline-dark" v-for="location_count,lcidx in location_counts"  v-bind:key="lcidx" style="margin: 5px;" @click="fetch_init(location_count)">{{ packet.locationsdict[location_count.location_id] }} ({{ location_count.cnt }})</b-button>
            </div>
        </b-card>

        <b-overlay :show="items_being_loaded" spinner-variant="primary" spinner-type="grow" spinner-small rounded="sm">
            <div v-if="items.length > 0" style="margin-top: 10px;">
                <b-card-text>Going from: {{ packet.locationsdict[location_id] }}</b-card-text>
                <table style="width: 100%;">
                    <thead>
                        <tr>
                            <td class="ipt_tdhr">
                                #
                            </td>
                            <td class="ipt_tdhr">
                                REQUEST DATE
                            </td>
                            <td class="ipt_tdhr">
                                INVOICE #
                            </td>
                            <td class="ipt_tdhr">
                                PRD
                            </td>
                            <td class="ipt_tdhr">
                                QTY
                            </td>
                            <td class="ipt_tdhr">
                                DESTINATION
                            </td>
                            <td class="ipt_tdhr">
                                PICKUP BY
                            </td>
                            <td class="ipt_tdhr" style="width: 150px;">
                                STATUS
                            </td>
                            <td class="ipt_tdhr">
                                ACTION
                            </td>
                            <!-- <td class="ipt_tdhr">
                                ACTION
                            </td> -->
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="item,idx in items" v-bind:key="idx">
                            <td class="ipt_tdhr" style="font-weight: normal;">
                                {{ idx + 1}}
                            </td>
                            <td class="ipt_tdhr" style="font-weight: normal;">
                                {{ parse_dt(item.delivery_date) }}
                            </td>
                            <td class="ipt_tdhr" style="font-weight: normal;" @click="navigateToInvoice(item.invoice_id)">
                                {{ item.invoice_id }}
                            </td>
                            <td class="ipt_tdhr" style="font-weight: normal;">
                                {{ item.product_sku }}
                                <div><b-badge v-if="item.is_special" variant="warning">SPECIAL</b-badge></div>
                            </td>
                            <td class="ipt_tdhr" style="font-weight: normal;">
                                {{ item.quantity }}
                            </td>

                            <td class="ipt_tdhr" style="font-weight: normal;">
                                <span v-if="item.order_type == 'store_pickup'">
                                    {{ packet.locationsdict[item.pick_location] }}
                                    <div>
                                        <b-badge variant="success">STORE PICKUP</b-badge>
                                    </div>
                                </span>
                                <span v-else-if="item.order_type == 'home_delivery'">
                                    <!-- <span>{{ packet.locationsdict[warehouse_location_id] }}</span> -->
                                    <span>CUSTOMER HOME</span>
                                    <div>
                                        <b-badge>HOME DELIVERY</b-badge>
                                    </div>
                                </span>  
                            </td>

                            <td class="ipt_tdhr" style="font-weight: normal;">
                                <div v-if="item.truck == 'customer_vehicle'">{{ packet.trucksdict[item.truck] }}</div>
                                <div v-else>

                                    <div v-if="item.truck">
                                        TRUCK: {{ packet.trucksdict[item.truck] }}
                                    </div>
                                    <div v-else>

                                    </div>
                                </div>
                            </td>
                            <td class="ipt_tdhr" style="font-weight: normal;">
                                <b-form-select style="font-size: 11px;" :options="states" v-model="item.state" :disabled="!item.truck">

                                </b-form-select>
                            </td>
                            <td class="ipt_tdhr" style="font-weight: normal;">
                                <b-button size="sm" variant="success" @click="mark_element(item)" :disabled="update_disabled">UPDATE</b-button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div v-else style="margin-top: 10px;">
                <b-alert show variant="warning">No Items</b-alert>
            </div>
        </b-overlay>
    </b-card>
</template>
<script>
    import moment from 'moment'
    import global_vars from '@/utilities/global_vars'
    import Backer from '@/components/globals/Backer'
    import Requestor from '@/utilities/Requestor'

    export default {
        name: "IncomingOutGoingOutGoing",
        components: {Backer},
        data: function(){
            return {
                states: [
                    {"value": null, "text": "NONE"},
                    {"value": "atpl", "text": "ADDED TO PULLIST"},
                    {"value": "pulled", "text": "PULLED"},
                    {"value": "picked", "text": "PICKED"},
                    {"value": "dropped", "text": "DROPPED"},
                    {"value": "rts", "text": "READY TO SHIP"},
                    {"value": "shipped", "text": "SHIPPED"},
                    {"value": "delivered", "text": "DELIVERED"},
                    {"value": "completed", "text": "COMPLETED"},
                ],
                states_dict: {
                    null: "NONE",
                    "atpl": "ADDED TO PULLIST",
                    "pulled": "PULLED",
                    "picked": "PICKED",
                    "dropped": "DROPPED",
                    "rts": "READY TO SHIP",
                    "shipped": "SHIPPED",
                    "delivered": "DELIVERED",
                    "completed": "COMPLETED",
                },
                packet: {},
                items: [],
                items_being_loaded: false,
                global_vars: global_vars,
                location_counts: [],
                location_id: null,
                warehouse_location_id: 4,
                update_disabled: false,
            }
        },
        methods: {
            parse_dt: function(dt){
                return moment(dt).format("MM-DD-YYYY")
            },
            fetch_init: function(location_count){
                let location_id = location_count.location_id;
                this.location_id = location_id;
                let that = this;
                let path = "/api/transfers/get_outgoing_items/"
                let data = {
                    location_id: location_id
                }
                let s = function(response){
                    if (response.data.result){
                        that.items = response.data.result;
                    }
                    else {
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    that.items_being_loaded = false;
                }
                let f = function(error){
                    console.log(error)
                    that.$bvToast.toast(
                        "Error loading outgoing items.",
                        {title: "Error", autoHideDelay: 1500, variant:"warning"}
                    );
                    that.items_being_loaded = false;
                }
                this.items_being_loaded = true;
                Requestor.getSyncP(path, data, this, s, f);
            },
            fetch_prereqs: function(){
                let that = this;
                // let location_id = this.packet.userDetails.properties.location_id;
                let prereqs = [
                    {
                        path:  "/api/transfers/get_outgoing_items_count_by_locations/",
                        //data: {location_id: location_id},
                        data: {},
                        type: "",
                        executable: Requestor.getAsync,
                        s: function(response){
                            if (response.data.result){
                                that.location_counts = response.data.result;
                            }
                            else {
                                that.$bvToast.toast(
                                    response.data.error, 
                                    {title: "Error", autoHideDelay: 1500, variant:"warning"}
                                );
                            }
                        },
                        f: function(error){
                            console.log(error)
                            that.$bvToast.toast(
                                "Error loading outgoing counts.",
                                {title: "Error", autoHideDelay: 1500, variant:"warning"}
                            );
                        }
                    },
                ]

                for (var i=0; i<prereqs.length; i++) {
                    let path = prereqs[i]["path"];
                    let data = prereqs[i]["data"];
                    let s = prereqs[i]["s"];
                    let f = prereqs[i]["f"];
                    let type = prereqs[i]["type"];
                    if (type == "secure") {
                        prereqs[i]["executable"](path, data, this, s, f);
                    }
                    else {
                        prereqs[i]["executable"](path, data, s, f);
                    }
                }
            },
            mark_element: function(item){
                let path = "/api/transfers/mark_element/"
                let that = this;
                let state = item.state;
                let data = {invoice_id: item.invoice_id, itemid: item.itemid, state: state}

                // if (state == "pulled"){
                //     data.pulled_by = this.packet.userDetails.username;
                //     data.pulled_ts = moment().format("MM-DD-YYYY HH:mm");
                //     data.pulled_status =  "pulled";
                // }
                // if (state == "cannot_be_pulled"){
                //     data.pulled_by = this.packet.userDetails.username;
                //     data.pulled_ts = moment().format("MM-DD-YYYY HH:mm");
                //     data.pulled_status =  "cannot_be_pulled";
                // }
                // if (state == "picked"){
                //     data.picked_by = this.packet.userDetails.username;
                //     data.picked_ts = moment().format("MM-DD-YYYY HH:mm");
                //     data.picked_status =  "picked";
                // }
                // if (state == "cannot_be_picked"){
                //     data.picked_by = this.packet.userDetails.username;
                //     data.picked_ts = moment().format("MM-DD-YYYY HH:mm");
                //     data.picked_status =  "cannot_be_picked";
                // }
                // if (state == "dropped"){
                //     data.dropped_by = this.packet.userDetails.username;
                //     data.dropped_ts = moment().format("MM-DD-YYYY HH:mm");
                //     data.dropped_status =  "dropped";
                // }
                // if (state == "cannot_be_dropped"){
                //     data.dropped_by = this.packet.userDetails.username;
                //     data.dropped_ts = moment().format("MM-DD-YYYY HH:mm");
                //     data.dropped_status =  "cannot_be_dropped";
                // }

                // if (state == "received"){
                //     data.received_by = this.packet.userDetails.username;
                //     data.received_ts = moment().format("MM-DD-YYYY HH:mm");
                //     data.received_status =  "received";
                // }
                // if (state == "cannot_be_received"){
                //     data.received_by = this.packet.userDetails.username;
                //     data.received_ts = moment().format("MM-DD-YYYY HH:mm");
                //     data.received_status =  "cannot_be_received";
                // }

                // if (state == "rts"){
                //     data.rts_by = this.packet.userDetails.username;
                //     data.rts_ts = moment().format("MM-DD-YYYY HH:mm");
                //     data.rts_status =  "rts";
                // }

                let s = function(response) {
                    if (response.data.error){
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    else {
                        that.$bvToast.toast(
                            "Updated.", 
                            {title: "Success", autoHideDelay: 1500, variant:"success"}
                        );
                    }
                    that.update_disabled = false;
                }

                let f = function(error) {
                    console.log(error)
                    that.$bvToast.toast(
                        "Error marking item. Please try again.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    that.update_disabled = false;
                }

                this.update_disabled = true;
                Requestor.postAsyncP(path, data, this, s, f);
            },
            navigateToInvoice: function(invoice_id) {
                let route = this.$router.resolve({path: "/sales/viewsale/"+invoice_id+"/"});
                window.open(route.href, '_blank');
            },
        },
        created: function() {
            this.packet = JSON.parse(localStorage.packet);
            this.packet.userDetails = JSON.parse(localStorage.userDetails);
            this.fetch_prereqs()
        }
    }
</script>

<style scoped>
    td {
        font-size: 11px;
    }
</style>


// WEBPACK FOOTER //
// src/components/IncomingOutGoing/IncomingOutGoingOutGoing.vue